// SPDX-License-Identifier: AGPL-3.0-only

import { createPinia, type Pinia } from "pinia";

export const pinia: Pinia = createPinia();
